import { FC, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Box from '@cloudscape-design/components/box';
import Container from '@cloudscape-design/components/container';
import Header from '@cloudscape-design/components/header';
import Button from '@cloudscape-design/components/button';
import Link from '@cloudscape-design/components/link';
import SpaceBetween from '@cloudscape-design/components/space-between';
import useUserProfile from 'src/hooks/useUserProfile';
import { Badge, Icon, TextContent } from '@cloudscape-design/components';
import routePaths from 'src/contstant/routePaths';

const LOCATION_DISPLAY_THRESHOLD = 10;

const PreferencesSection = () => {
  const navigate = useNavigate();
  const [showAllLocations, setShowAllLocations] = useState(false);
  const { getUserBusinessUnitName, getLocations } = useUserProfile();

  return (
    <Container
      data-testid="preferences-container"
      header={
        <Header data-testid="preferences-header" variant="h2">
          Your Preferences
        </Header>
      }
    >
      <SpaceBetween data-testid="preferences-space-between" direction="vertical" size="l">
        <Box data-testid="business-unit-section">
          <Box data-testid="business-unit-header" padding={{ bottom: 's' }}>
            <Icon data-testid="business-unit-icon" name="settings" variant="link" />
            <Box
              data-testid="business-unit-label"
              display="inline"
              margin={{ left: 's' }}
              variant="strong"
            >
              Preferred Business Unit
            </Box>
          </Box>
          <Box
            data-testid="business-unit-content"
            color="text-body-secondary"
            padding={{ left: 'xl' }}
          >
            <TextContent data-testid="business-unit-text">
              <p>{getUserBusinessUnitName()}</p>
            </TextContent>
          </Box>
        </Box>

        <Box data-testid="locations-section">
          <Box data-testid="locations-header" padding={{ bottom: 's' }}>
            <Icon data-testid="locations-icon" name="share" variant="link" />
            <Box
              data-testid="locations-label"
              display="inline"
              margin={{ left: 's' }}
              variant="strong"
            >
              Preferred Locations ({getLocations()?.length || 0})
            </Box>
          </Box>
          <Box
            data-testid="locations-content"
            color="text-body-secondary"
            padding={{ left: 'xl' }}
          >
            <div
              data-testid="locations-list"
              style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}
            >
              {(showAllLocations
                ? getLocations()
                : getLocations()?.slice(0, LOCATION_DISPLAY_THRESHOLD)
              )?.map((data) => (
                <span
                  key={data}
                  data-testid={`location-badge-${data}`}
                  style={{
                    background: '#e9f3ff',
                    color: '#0972d3',
                    padding: '2px 8px',
                    borderRadius: '4px',
                    fontSize: '12px',
                    border: '1px solid #d5dbdb',
                    whiteSpace: 'nowrap',
                    display: 'inline-block',
                  }}
                >
                  {data}
                </span>
              ))}
              {(getLocations()?.length || 0) > LOCATION_DISPLAY_THRESHOLD && (
                <Button
                  data-testid="show-more-locations-button"
                  variant="inline-link"
                  onClick={() => navigate(routePaths.PROFILE_PREFERENCES.path)}
                >
                  {showAllLocations
                    ? 'Show less'
                    : `+${(getLocations()?.length || 0) - LOCATION_DISPLAY_THRESHOLD} more`}
                </Button>
              )}
            </div>
          </Box>
        </Box>

        <Box data-testid="manage-preferences-section">
          <Link
            data-testid="manage-preferences-link"
            href="#"
            variant="primary"
            onFollow={() => navigate(routePaths.PROFILE_PREFERENCES.path)}
          >
            Manage preferences
          </Link>
        </Box>
      </SpaceBetween>
    </Container>
  );
};

export default PreferencesSection;
